import React from 'react';
import { WEIGHTS, SIZE, TYPOGRAPHY_COLOR_TYPES } from '../globalTypes';
import { getTypographyStyles } from './styleUtils';

export interface TypographyProps {
	children: React.ReactNode;
	type?: 'text' | 'display';
	size?: SIZE;
	weight?: WEIGHTS;
	color?: TYPOGRAPHY_COLOR_TYPES;
}

export const Typography: React.FC<TypographyProps> = ({
	children,
	type = 'text',
	size = 'md',
	weight = 'regular',
	color = 'default'
}) => {
	const styles = getTypographyStyles(size, weight, type, color);
	return <span style={styles}>{children}</span>;
};
